import * as React from "react";
const SvgPaymentOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M13.275 17.5h2.4v-.075L11.55 13.05l.025-.075h.25q1.35 0 2.238-.825t1.087-1.925h1V9.05h-1.025a2.5 2.5 0 0 0-.262-.713 4 4 0 0 0-.463-.662h1.75V6.5h-8.3v1.425h3.9q.65 0 1.063.325t.562.8H7.85v1.175h5.55a1.8 1.8 0 0 1-.575.863q-.425.362-1.15.362h-2.5v1.6zM12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q2.075 0 3.9.788a10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
    />
  </svg>
);
export default SvgPaymentOutlined;
